import { Box, Typography, Button, List, ListItem, FormControl, FormLabel, Input, IconButton } from "@mui/joy";
import { useState } from "react";
import { TextInput } from "../../utils/input";
import { toast } from "react-toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import { useRegisterUserMutation, useSendOtpMutation, useVerifyOTPMutation } from "../../services/auth/authApiSlice";
import Loading from "../../components/Common/Loading";
import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";

const VerifyMobile = () => {
  const navigate = useNavigate();

  const [passwordUpdate, setPasswordUpdate] = useState(true);
  const [phone, setPhone] = useState("");
  const [userOpt, setUserOpt] = useState("");
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [registerUser, { isLoading }] = useRegisterUserMutation();
  const [sendOtp, { isLoading: sendOtpLoading }] = useSendOtpMutation();
  const [verifyOTP, { isLoading: verifyOtpLoading }] = useVerifyOTPMutation();

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState<boolean>(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value) && value.length < 11) {
      setPhone(value);
    }
  };
  const handleInputOtp = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value) && value.length < 7) {
      setUserOpt(value);
    }
  };

  const handleSendOtp = async () => {
    try {
      const response = await sendOtp({ mobile: phone }).unwrap();

      if (response?.success) {
        toast.success(response?.message);
        setIsOtpSent(true);
      } else {
        toast.error(`Error Sending OTP: ${response?.message}`);
      }
      // Call OTP send API here
    } catch (err) {
      toast.error(`Error Sending OTP: ${err?.data?.message || err?.message}`);
    }
  };

  const handleVerifyOtp = async () => {
    // try {
    //   const response = await verifyOTP({ otp: userOpt}).unwrap();
    //   if (response?.success) {
    //     toast.success(response?.message);
    //     setIsOtpVerified(true);
    //   } else {
    //     toast.error(`Error Verifying OTP: ${response?.message}`);
    //   }
    // } catch (err) {
    //   toast.error(`Error Verifying OTP: ${err?.data?.message}`);
    // }
  };

  const handleResgisterClick = async () => {
    try {
      const payload: any = {};
      const result = await registerUser(payload).unwrap();
      if (result?.success) {
        toast.success(result?.message);
        navigate("/login", { replace: true });
      } else {
        toast.error(result?.message);
      }
    } catch (err) {
      toast.error(err?.data?.message || err?.message);
    }
  };
  const otpFormControlSx = {
    width: "100%",
    ...(isOtpVerified && {
      "& .MuiInput-root": {
        backgroundColor: "#e8f5e8",
        borderColor: "#4caf50",
      },
      "& .MuiInput-root:focus-within": {
        borderColor: "#4caf50",
      },
    }),
  };
  const validatePassword = (password: string) => {
    return {
      minLength: password.length >= 8,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
  };
  const formControlSx = { width: "100%" };
  const passwordValidation = validatePassword(password);
  const isPasswordValid = Object.values(passwordValidation).every(Boolean);
  const isPasswordMatched = password === repeatPassword;
  const ValidationItem = ({ isValid, text }: { isValid: boolean; text: string }) => (
    <ListItem sx={{ py: 0.5, px: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {isValid ? <CheckIcon sx={{ color: "#4caf50", fontSize: 16 }} /> : <CloseIcon sx={{ color: "#f44336", fontSize: 16 }} />}
        <Typography level="body-sm" sx={{ color: isValid ? "#4caf50" : "#f44336" }}>
          {text}
        </Typography>
      </Box>
    </ListItem>
  );

  return isLoading ? (
    <Loading isLoading={isLoading} />
  ) : (
    <Box
      className="verifymobile register-box"
      sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", px: 3, py: 3, gap: 2, maxWidth: 500, margin: "auto" }}
    >
      <Typography level="h3" textAlign="center" className="heading-2">
        Verify Mobile Number
      </Typography>

      <TextInput
        className="phone_number"
        name="phone"
        label="Phone Number"
        value={phone}
        onChange={handleInputChange}
        required
        placeholder="Enter 10-digit Phone Number"
        disabled={isOtpVerified}
      />

      {isOtpSent && (
        <>
          <Box sx={{ position: "relative", width: "100%" }}>
            <TextInput
              name="otp"
              label="OTP"
              formControlSx={otpFormControlSx}
              value={userOpt}
              onChange={handleInputOtp}
              required
              placeholder="Enter OTP"
              disabled={isOtpVerified}
            />
            {isOtpVerified && (
              <CheckCircleIcon
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 42,
                  transform: "translateY(-50%)",
                  color: "#4caf50",
                  fontSize: 24,
                }}
              />
            )}
          </Box>
          {!isOtpVerified && (
            <Button color="primary" variant="outlined" loading={verifyOtpLoading} onClick={handleVerifyOtp} sx={{ mt: 2, width: "100%" }} disabled={userOpt?.length < 6}>
              Verify OTP
            </Button>
          )}
        </>
      )}

      {isOtpVerified && (
        <div style={{ width: "100%" }}>
          <Typography>
            <b>Vendor Code:</b> {"0010500000"}{" "}
          </Typography>
        </div>
      )}
      {isOtpVerified && (
        <div style={{ width: "100%" }}>
          <Typography>
            <b>Vendor Name:</b> {"SATYAR"}{" "}
          </Typography>
        </div>
      )}

      {isOtpVerified && (
        <>
          <FormControl sx={formControlSx} required>
            <FormLabel sx={{ fontWeight: "bold" }}>Password</FormLabel>
            <Input
              name="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter Password"
              endDecorator={
                <IconButton onClick={() => setShowPassword(!showPassword)} sx={{ p: 0.5 }}>
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              }
            />
          </FormControl>

          {/* Repeat Password Field with Eye Button */}
          <FormControl sx={formControlSx} required>
            <FormLabel sx={{ fontWeight: "bold" }}>Repeat Password</FormLabel>
            <Input
              name="repeatPassword"
              type={showRepeatPassword ? "text" : "password"}
              value={repeatPassword}
              onChange={(event) => setRepeatPassword(event.target.value)}
              placeholder="Enter Password Again"
              endDecorator={
                <IconButton onClick={() => setShowRepeatPassword(!showRepeatPassword)} sx={{ p: 0.5 }}>
                  {showRepeatPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              }
            />
          </FormControl>
        </>
      )}

      {!isOtpSent && (
        <Button
          color="primary"
          disabled={!(phone.length === 10)}
          loading={sendOtpLoading}
          variant="solid"
          onClick={handleSendOtp}
          className="heading-4"
          sx={{ mt: 2, width: "100%" }}
        >
          Send OTP
        </Button>
      )}

      {isOtpVerified && (
        <Button
          className="heading-4"
          color="success"
          variant="solid"
          sx={{ mt: 2, width: "100%" }}
          onClick={handleResgisterClick}
          disabled={!isPasswordValid || !isPasswordMatched}
        >
          Set Password
        </Button>
      )}

      {(password.length > 0 || repeatPassword.length > 0) && (
        <Box sx={{ width: "100%", mt: 1 }}>
          <Typography level="body-sm" sx={{ mb: 1, fontWeight: "medium" }}>
            Password Requirements:
          </Typography>
          <List sx={{ py: 0 }}>
            <ValidationItem isValid={isPasswordMatched} text="Passwords should match" />
            <ValidationItem isValid={passwordValidation.minLength} text="At least 8 characters" />
            <ValidationItem isValid={passwordValidation.hasUppercase} text="At least one uppercase letter" />
            <ValidationItem isValid={passwordValidation.hasLowercase} text="At least one lowercase letter" />
            <ValidationItem isValid={passwordValidation.hasNumber} text="At least one number" />
            <ValidationItem isValid={passwordValidation.hasSpecialChar} text="At least one special character (!@#$%^&*)" />
          </List>
        </Box>
      )}
      <Modal open={passwordUpdate} onClose={() => setPasswordUpdate(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Typography id="modal-modal-title" component="h2">
            Text in a modal
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
          </Typography>
        </Box>
      </Modal>
    </Box>
  );
};

export default VerifyMobile;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  border: "0px solid #000",
  outline: "0px",
  p: 4,
};
